import { defineComponent as _defineComponent } from 'vue'
import { watchEffect, ref } from '../../../../adapter-vue';
import { TUITranslateService, IMessageModel } from '@tencentcloud/chat-uikit-engine';
import { isUrl, JSONToObject } from '../../../../utils/index';
import { CHAT_MSG_CUSTOM_TYPE } from '../../../../constant';
import { ICustomMessagePayload } from '../../../../interface';
import Icon from '../../../common/Icon.vue';
import star from '../../../../assets/icon/star-light.png';
interface Props {
  messageItem: IMessageModel;
  content: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'message-custom',
  props: {
    messageItem: { default: undefined },
    content: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { messageItem: IMessageModel, content: any }



const custom = ref();
const message = ref<IMessageModel>();
const extension = ref();
const isCustom = ref<ICustomMessagePayload>({
  businessID: '',
});

watchEffect(() => {
  custom.value = props.content;
  message.value = props.messageItem;
  const { payload } = props.messageItem;
  isCustom.value = payload.data || '';
  isCustom.value = JSONToObject(payload.data);
  if (payload.data === CHAT_MSG_CUSTOM_TYPE.SERVICE) {
    extension.value = JSONToObject(payload.extension);
  }
});
const openLink = (url: any) => {
  window.open(url);
};

return { __sfc: true,props, custom, message, extension, isCustom, openLink, TUITranslateService, isUrl, CHAT_MSG_CUSTOM_TYPE, Icon, star }
}

})